<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container
        v-if="!loading && items.length"
        class="py-10 py-md-13 py-lg-16 position-relative items"
      >
        <TitleWidget>Quem já Confiou</TitleWidget>

        <v-row class="mt-8 mt-md-12">
          <v-col v-for="(item, i) in items" :key="i" cols="6" sm="4" md="2">
            <TooltipWidget bottom :tip="item.title">
              <ClientCard v-bind="item" />
            </TooltipWidget>
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import ClientCard from "../cards/ClientCard.vue";
import TooltipWidget from "../widgets/TooltipWidget.vue";

const _config = {
  mod: "clients",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    ClientCard,
    TooltipWidget,
  },
};
</script>

<style lang="scss" scoped>
.items {
  &:after {
    background-image: url(../../assets/img/points-bg.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    bottom: -100px;
    content: "";
    height: 200px;
    position: absolute;
    left: 100%;
    width: 200px;
  }
}
</style>
